import React, { Component } from 'react';
import Formulario from './VisitadorForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Visitador extends Component{
    
    componentDidMount = () => {
        const { getModulo, listarColaborador, listar, limpiarDatos, getPais } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        listarColaborador(modulo[7]);
        listar();
        limpiarDatos();
        getPais(modulo[7]);
    }
    
    render(){
        const { listarColaborador, loader, modulo, agregarVisitador, emp, data,
            eliminar, datosColaborador, cargo, paisN } = this.props;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    modulo = {modulo}
                    listarColaborador = {listarColaborador}
                    agregarVisitador = {agregarVisitador}
                    emp = {emp}
                    data = {data}
                    eliminar = {eliminar}
                    datosColaborador = {datosColaborador}
                    cargo = {cargo}
                    paisN = {paisN}
                />
            </LoadMask>
        );
    }
}

export default Visitador;